import { enableProdMode } from '@angular/core';
import { environment } from '@environments/environment';

import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

// const originalAssign = Location.prototype.assign;
// const originalReplace = Location.prototype.replace;

// Location.prototype.assign = function (url: string) {
//     console.error('REDIRECT DETECTED - Location.assign:', {
//         url,
//         currentUrl: this.href,
//         stack: new Error().stack,
//         timestamp: new Date().toISOString(),
//     });
//     return originalAssign.call(this, url);
// };

// Location.prototype.replace = function (url: string) {
//     console.error('REDIRECT DETECTED - Location.replace:', {
//         url,
//         currentUrl: this.href,
//         stack: new Error().stack,
//         timestamp: new Date().toISOString(),
//     });
//     return originalReplace.call(this, url);
// };

if (environment.production) {
    enableProdMode();
} else {
    // Create the styled prefix for info and debug logs
    const prefix = '%cOrchestrators%c'; // the starting %c indicates "all text after this marker should have styling". the closing %c indicates to stop styling.
    const prefixStyle = 'background-color: #2243A2; color: white; padding: 4px; border-radius: 4px;';
    const resetStyle = '';

    const originalDebug = console.debug;
    console.debug = function (...args: any[]) {
        originalDebug.apply(console, [prefix, prefixStyle, resetStyle, ...args]);
    };

    const originalInfo = console.info;
    console.info = function (...args: any[]) {
        originalInfo.apply(console, [prefix, prefixStyle, resetStyle, ...args]);
    };

    const originalLog = console.log;
    console.log = function (...args: any[]) {
        originalLog.apply(console, [prefix, prefixStyle, resetStyle, ...args]);
    };

    const originalWarn = console.warn;
    console.warn = function (...args: any[]) {
        originalWarn.apply(console, ['Orchestrators', '', resetStyle, ...args]); // prefix without styling
    };

    const originalError = console.error;
    console.error = function (...args: any[]) {
        originalError.apply(console, ['Orchestrators', '', resetStyle, ...args]); // prefix without styling
    };
}

bootstrapApplication(AppComponent, appConfig).catch((err) => {
    if (!environment.production) console.error(err);
});
